import styled from "styled-components";

export const SSelectOrganizationStepListItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;
